// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__2ygGW","close":"styles_close__3jsdU","select":"styles_select__Sf9MB","downloadSuccess":"styles_downloadSuccess__x7ij7"};